import { useSortable } from '@dnd-kit/sortable';
import React, { useContext, createContext } from 'react';
import { CSS } from '@dnd-kit/utilities';
import tw from 'twin.macro';

const ToggleContext = createContext(null as any);

export function useDragListeners() {
  return useContext(ToggleContext);
}

export function SortableItem(props) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: props.id,
  });

  const { children, ...rest } = props;
  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
  };

  return (
    <ToggleContext.Provider value={{ listeners }}>
      <div
        style={style}
        css={[tw`outline-none`, isDragging && tw`opacity-0`]}
        {...rest}
        ref={setNodeRef}
        {...attributes}
      >
        {children}
      </div>
    </ToggleContext.Provider>
  );
}
